<div class="option-text">{{ departmentEntity.Name }} <span class="font-light" *ngIf="departmentEntity.Spartennummer as c">{{c}}</span></div>
<div class="edit-button">
    <button app-round-button matTooltip="Bearbeiten" matTooltipPosition="left" (click)="$event.stopPropagation(); edit(departmentEntity)">
        <fa-icon icon="pencil-alt"></fa-icon>
    </button>
</div>

